<template>
  <div v-if="imagesEmpty == 1 && isUpdateNow == 0" class="sync-images">
    <a
      role="button"
      class="mid-button text-center btn-primary extra-rounded btn-lg dark-bg extra-rounded text-center text-decoration-none"
      @click.stop="getImages"
    >Last inn bilder</a>
  </div>
  <div v-else-if="isUpdateNow == 1" class="sync-images color-red">
    Bilder lastes ned. Vennligst last inn siden på nytt om et øyeblikk.
  </div>
</template>

<script>
export default {
  props: {
    link: {
      type: String,
      required: true
    },
    imagesEmpty: {
      type: Number,
      default: 0
    },
    imagesUpdate: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isUpdateNow: this.imagesUpdate
    }
  },

  methods: {
    getImages() {
      this.isUpdateNow = 1;
      axios({
        url: this.link,
        method: 'PUT'
      });
    }
  },
}
</script>
<style scoped>
.sync-images {
  display: flex;
  justify-content: center;
  margin: 10px 0;
}
.color-red {
  color: red;
}
</style>



